// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SET_GPU_MODELS = 'gpu-models/SET_GPU_MODELS_LIST';
